import React, { useState } from 'react'

export default function NumberPad({onConfirm, onCancel}) {
  const [dValue, setNum] = useState('0');

  function select(o) {
    const n = o.d;
    let v = dValue === '0' ? '': dValue;
    if (n === '<') {
        if (v.length <= 1)
            v = '0';
        else
            v = v.slice(0,-1) ;

        setNum(v);
        return;
    };
    v += n;
    //console.log('dValue', v);
    setNum(v);
  }

  function Digit(v) {
    const d = v.value;
    return (
        <div className={digit} onClick={()=>select({d})}>{d}</div>
    )
  }

  function cancel() {
    onCancel();
  }

  function enter() {
    console.log('enter', dValue);
    onConfirm(dValue);
  }

  const digit = 'text-center border-black border-2 py-4 hover:cursor-pointer rounded-md'
  const btnc = digit + ' bg-red-300';
  const btne = digit + ' bg-green-300';
  return (
    <div className='mx-10 select-none'>
        <div className='w-full mb-2 p-2 border-2 border-black text-4xl font-bold'>
            {dValue}
        </div>
        <div className='grid grid-cols-3 gap-2 text-5xl font-bold'>
            <Digit value='1'/>
            <Digit value='2'/>
            <Digit value='3'/>
            <Digit value='4'/>
            <Digit value='5'/>
            <Digit value='6'/>
            <Digit value='7'/>
            <Digit value='8'/>
            <Digit value='9'/>
            <Digit value='.'/>
            <Digit value='0'/>
            <Digit value='&#60;'/>
        </div>
        <div className='grid grid-cols-2 mt-2 gap-2 text-3xl font-bold'>
            <div className={btnc} onClick={()=>cancel()}>Cancel</div>
            <div className={btne} onClick={()=>enter()}>Enter</div>
        </div>
    </div>
  )
}
